module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/email.11e2c71f.svg";